export default __webpack_public_path__ + "static/media/double_bee_image.957e6847.png";